/**
 * The typed expired-result error (analyze-table-polish D19).
 *
 * A read under a result token the server no longer holds (its 30-minute life
 * ran out, or a licence or a denied renewal deleted the session's tokens)
 * answers ONE error from every reader: 422 with `code: 'result_expired'` beside
 * the message. `apiClient.baseFetch` lifts the body's `error` to `err.code`, so
 * the code arrives on `err.details`.
 *
 * WHY THE TEST HAS ITS OWN LEAF
 * -----------------------------
 * The public pages' boot closure reaches it (`utils/expectedRefusal.js`, which
 * `apiClient` loads), and it carries what it statically imports. The per-result
 * channel (`utils/resultExpired.js`) holds module-level state, so nothing
 * tree-shakes it: this file holds the pure test, with no state and no imports,
 * and `resultExpired.js` re-exports it for every other reader (th-jou3tw).
 */
export function isResultExpiredError(err) {
  return err?.status === 422 && err?.details?.code === 'result_expired'
}
